// 用户相关API
import http from './http'

export default class UserAPI {
	//获取用户信息
	static frontUserInfo () {
		return http.httpGet('/lavrock/getFrontUserInfo')
	}

	//登录
	static login (data) {
		return http.httpPost('/lavrock/userLogin', data)
	}

	//注销
	static logout () {
		return http.httpGet('/lavrock/logout')
	}

	//注册
	static register (data) {
		return http.httpPost('/lavrock/user/manager/register', data)
	}

	//获取验证码
	static getCode (data) {
		return http.httpGet('/lavrock/user/manager/sendMessageToPhone', data)
	}

	//验证验证码
	static checkCode (data) {
		return http.httpGet('/lavrock/user/manager/getMessageToPhone', data)
	}
	//验证手机是否可用
	static checkPhone (data) {
		return http.httpGet('/lavrock/user/manager/check', data)
	}

	//更换绑定手机
	static updateMobile (data) {
		return http.httpGet('/lavrock/user/logged/updateMobile', data)
	}

	//用户旧密码校验
	static checkPassword (data) {
		return http.httpPost('/user/logged/checkPassword', data)
	}

	//用户修改密码
	static updatePassword (data) {
		return http.httpPost('/lavrock/user/logged/updatePassword', data)
	}

	//获取微信二维码
	static qrAuthorize (data) {
		return http.httpGet('/lavrock/Authorize/qrAuthorize', data)
	}


	//获取老板微信二维码
	static getUserInfo (data) {
		return http.httpGet('/admin/user/invitation', data)
	}

	//是否有绑定微信
	static getIsBand (data) {
		return http.httpGet('/admin/user/isBand', data)
	}

	//通过openid获取用户信息
	static userLoginByCode (data) {
		return http.httpPost('/lavrock/userLogin', data)
	}

	//更新微信绑定
	static updateQrOpenid (data) {
		return http.httpGet('/lavrock/user/logged/updateQrOpenid', data)
	}

	//微信解绑
	static unbingQrOpenid (data) {
		return http.httpGet('/lavrock/user/logged/unbingQrOpenid', data)
	}

	//获取企业信息
	static enterpriseInfo () {
		return http.httpGet('/lavrock/user/logged/getEnterpriseInfo')
	}

	//修改企业信息
	static saveEnterpriseInfo (data) {
		return http.httpPost('/lavrock/user/logged/saveEnterpriseInfo', data)
	}

	//七牛token
	static upToken () {
		return http.httpGet('/lavrock/common/upToken')
	}

	//取消用户提示
	static updTipStatus (data) {
		return http.httpGet('/lavrock/auth/common/updTipStatus', data)
	}



	//用户单独校验验证码
	static changepwd (data) {
		return http.httpPost('/lavrock/user/manager/changepwd', data)
	}

	static authorizeLogin (params) {
		return http.httpGet('/Authorize/ologin', params)
	}

	//获取用户相关配置
	static getConfig (params) {
		return http.httpGet('/user/manager/config', params)
	}

	//保存用户激活配置
	static getActive (params) {
		return http.httpGet('/user/manager/active', params)
	}
	//调研表弹框
	static getSysConfig (params) {
		return http.httpGet('/auth/common/sys/config', params)
	}
	//获取激活提醒记录
	static orderActivate (params) {
		return http.httpGet('/order/orderActivate', params)
	}
	//确认激活提醒
	static confirmOrderActivate (params) {
		return http.httpPost('/order/confirmOrderActivate', params)
	}
	//获取用户站点到期时间
	static findUserExpireTime (params) {
		return http.httpGet('/order/findUserExpireTime', params)
	}

	//判断用户是否开通视频云
	static getUserBuyAuthority (params) {
		return http.httpGet('/polyv/playduration/isSetMeal', params)
	}
    // 获取ftp信息
    static getFtpInfo (params) {
		return http.httpGet('/admin/enterpriseManagement/ftp', params)
	}
}
